<template>
  <div id="ebs-loading">
    <h2
      id="ebs-title"
      v-html="translate('title')"
    />
    <p v-html="translate('instructions')" />
    <v-progress-circular
      v-if="!loadingError"
      id="spinner"
      indeterminate
      :size="50"
    />
    <v-icon
      v-else
      class="alert"
      :size="50"
    >
      mdi-alert-circle
    </v-icon>
    <div id="bottom-message-container">
      <v-carousel
        id="message-carousel"
        v-model="carousel"
        :interval="10000"
        :cycle="true"
        height="280"
        hide-delimiter-background
        light
      >
        <v-carousel-item
          v-for="(message, i) in messages"
          :key="i"
          class="message-container"
          color="rgb(241, 241, 241)"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
          <v-sheet height="100%">
            <v-row
              class="fill-height"
              align="center"
              justify="center"
            >
              <h3
                v-html="translate('message_title')"
              />
              <p v-html="message" />
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>
<script>
import captureSentryException from '../tracking/sentry/captureSentryException';
import redirectTo from '../lib/routerHelpers/redirectTo';

export default {
  data() {
    return {
      loadingError:       false,
      ebsPollingTimeout:  120000, // 2 min,
      ebsPollingInterval: 10000, // 10 sec
      carousel:           0,
      messages:           [
        this.$t('components.ebs_loading.bottom_messages.one'),
        this.$t('components.ebs_loading.bottom_messages.two'),
        this.$t('components.ebs_loading.bottom_messages.three'),
        this.$t('components.ebs_loading.bottom_messages.four'),
        this.$t('components.ebs_loading.bottom_messages.five'),
        this.$t('components.ebs_loading.bottom_messages.six'),
        this.$t('components.ebs_loading.bottom_messages.seven'),
      ],
    };
  },
  mounted() {
    setTimeout(
      this.handleUnderwritingCompletePolling,
      this.ebsPollingInterval,
    );
  },
  methods: {
    translate(key) {
      return this.$t(`components.ebs_loading.${key}`);
    },
    async handleUnderwritingCompletePolling() {
      try {
        const loanApp = await this.pollForUnderwritingComplete();
        if (loanApp.loan_application_status === 'underwriting_approved') {
          this.$router.push('/loan_applications/loan_offers');
        } else {
          redirectTo('/contract/decline', '/v/financeiro/ebs');
        }
      } catch (e) {
        this.flash(this.$t('pages.reg_ebs.bank_error'), 'error');
        this.loadingError = true;
        captureSentryException(e);
      }
    },
    async pollForUnderwritingComplete() {
      const endTime = Number(new Date()) + this.ebsPollingTimeout;
      const checkCondition = async (resolve, reject) => {
        await this.$store.dispatch('fetchAndUpdateState');
        const loanApp = this.$store.state.loanApplication;
        let status;
        if (loanApp) {
          status = loanApp.loan_application_status;
        } else {
          reject(new Error('no loan application in fetch state response'));
        }
        const completeStatuses = ['underwriting_approved', 'underwriting_declined'];

        if (completeStatuses.includes(status)) {
          resolve(loanApp);
        } else if (Number(new Date()) < endTime) {
          setTimeout(checkCondition, this.ebsPollingInterval, resolve, reject);
        } else {
          reject(new Error('ebs polling timed out'));
        }
      };

      return new Promise(checkCondition);
    },
  },
};
</script>
<style lang="scss">
  #ebs-loading {
    text-align: center;
    #ebs-title {
      margin-bottom: 0.5rem;
    }
    #spinner, .alert {
      margin: 45px auto;
    }
    #bottom-message-container {
      background-color: #f3f3f3;
      padding: 2em 1em;
      margin: 0 auto 4em auto;
      max-width: 600px;

      .v-window {
        overflow: visible;
      }

      .v-carousel__controls {
        display: none;
      }
    }
    #message-carousel {
      p {
        color: #4a4a4a;
        padding: 0 4em;
        line-height: 1.8em;
        font-family: "Open Sans", sans-serif;
        font-size: 1.2em;
      }
      .row {
        justify-content: center;

        h3 {
          font-weight: 400;
          font-family: "Bree Serif", serif;
          margin-bottom: 1em;
          color: #05a006;
          font-size: 1.3em;
        }
      }
      .v-window__next {
        right: -14px;
      }
      .v-window__prev {
        left: -14px;
      }
      .v-window__prev, .v-window__next {
        background: none;
      }
      .v-sheet {
        background: none;
      }
      .v-carousel__controls {
        bottom: -14px;
      }
      .v-item--active.v-btn--active {
        color: #f5bf05;
      }
    }
  }
  @media (min-width: 450px) {
    #ebs-loading {
      #message-carousel {
        .row {
          p {
            font-size: 1.4em;
          }
          h3 {
            font-size: 1.6em;
          }
        }
      }
      #bottom-message-container {
        padding: 2em;

        .v-carousel__controls {
          display: flex;
        }
      }
    }
  }
</style>
